export default function SectionLabel({ code, title, kicker, align = "left" }) {
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      <div className="flex items-center gap-3 mb-5">
        <span className="overline">{code}</span>
        <span className="h-px w-12 bg-hairline-dark" />
        <span className="overline">{kicker}</span>
      </div>
      <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black tracking-tight text-navy">
        {title}
      </h2>
    </div>
  );
}
